import React, {FC, useState} from "react"

import {FormattedMessage, getMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import MultiChipsSelect from "@irati/ui/src/MultiChipsSelect"
import Validation from "@irati/utils/validation"
import theme from "@irati/ui/src/global/theme"
import {Chip} from "@irati/ui/src/MultiChipsSelect/styled"
import {Body} from "@irati/ui/src/Typography"
import {updateOAuthSettings} from "@irati/sso/services/sso"
import authentication from "@irati/auth"
import {OAuthProvider} from "@irati/types"
import {getErrorMessage, getErrorValues} from "@irati/utils/lang/formatError"
import ErrorText from "@irati/ui/src/ErrorText"
import adminTracking from "@irati-tracking/admin"

const SSO_EDIT_DOMAINS = "SSO_editEmailDomains"

interface Props extends InjectIntl {
  provider: OAuthProvider
  items?: string[]
}

const EditDomains: FC<Props> = ({provider, items, formatMessage}) => {
  const [isEditable, setIsEditable] = useState<boolean>(false)
  const [domains, setDomains] = useState<string[]>(items || [])
  const [error, setError] = useState<string>()

  const onEdit = () => {
    adminTracking.editIntegrationSSOJourney(SSO_EDIT_DOMAINS)
    if (isEditable) {
      setError("")
      updateOAuthSettings(authentication.business().uuid, provider, domains)
        .then(() => {
          setIsEditable(false)
        })
        .catch((err) => {
          const message = getMessage(formatMessage, getErrorMessage(err), getErrorValues(err))
          setError(message)
        })
    } else {
      setIsEditable(true)
    }
  }

  return (
    <>
      <Flex justifyContent="space-between" marginBottom={!isEditable ? 3 : 1}>
        {!isEditable ? (
          <Flex wrap="wrap" gap={theme.spacing.one}>
            {domains.map((value) => (
              <Chip readOnly>
                <Body color={theme.colors.filterChip}>{value}</Body>
              </Chip>
            ))}
          </Flex>
        ) : (
          <MultiChipsSelect
            name="domainsMultiChipsSelect"
            alignChips="end"
            width={85}
            items={domains}
            onChange={(values: string[]) => setDomains(values)}
            placeholder={formatMessage({id: "admin.components.integration.sso.enableSSO.oauth.step2.addDomains"})}
            validation={Validation.string().matches(
              /^$|^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
              "platform.defaultValidation.domain"
            )}
          />
        )}
        <div>
          <Button id={isEditable ? "OAUTHDomainsSave_button" : "OAUTHDomainsEdit_button"} onClick={onEdit}>
            {isEditable ? (
              <FormattedMessage id="admin.components.integration.sso.editSSO.edit.domainsSaveBtn" />
            ) : (
              <FormattedMessage id="admin.components.integration.sso.editSSO.edit.domainsBtn" />
            )}
          </Button>
        </div>
      </Flex>
      {error && <ErrorText>{error}</ErrorText>}
    </>
  )
}

export default injectIntl(EditDomains)
